import {getMethod} from '~/api'

async function get(productTypeName) {
    return await getMethod(`/api/priceListCodes/${productTypeName}`)
}

export {get}
